export default __webpack_public_path__ + "static/media/86t.dd3d0400.jpg";